import Button from '../../components/v2/Button/Button';
import { Typography } from '../../components/v2/Typography/Typography';
import { OrdainedStatus } from '../../api/ordained';
import { SUPPORT_EMAIL } from '../../constants/brand';

type Props = {
  onClose: () => void;
  status?: OrdainedStatus | null;
};

const PCOLockedSummary = ({ onClose, status }: Props) => {
  const isRefunded = status === 'Refunded';

  return (
    <div className='max-w-[500px] flex flex-col justify-center items-center text-center py-4'>
      <Typography type='display-100' className='max-w-[436px] mt-6'>
        {isRefunded
          ? 'Your order has been cancelled/refunded. Please contact support if this is a mistake.'
          : 'Your documents have been printed and will be on their way soon.'}
      </Typography>
      {!isRefunded && (
        <Typography
          type='body-400'
          variant='functional-low'
          className='mt-6 max-w-[436px]'
        >
          <>
            If you need any urgent changes, please email us at{' '}
            <a className='underline' href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>
          </>
        </Typography>
      )}
      <Button className='mt-8' onClick={onClose}>
        Close
      </Button>
    </div>
  );
};

export default PCOLockedSummary;
